import { useUserContext } from '@oceanjs/core';
import React from 'react';
import { ApolloProvider, ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { fetch } from 'whatwg-fetch';


/*
import introspectionQueryResultData from '../../generated/fragmentTypes.json';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: introspectionQueryResultData
});
*/

const cache = new InMemoryCache();

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_APOLLO_URI,
  fetch: fetch
});

/*
 * Documentation for Apollo 3.x
 * https://www.apollographql.com/docs/react/migrating/apollo-client-3-migration/
 * https://www.apollographql.com/docs/react/networking/authentication/
 * 
 */
export const NetworkProvider: React.FC = ({ children }) => {
  const userContext = useUserContext();

  const authLink = setContext( async (_, { headers }) => {
    // @ts-ignore
    const auth = await userContext.getAuthenticationToken();
    if (auth) {
      return {
        headers: {
          ...headers,
          authorization: auth
        }
      }
    } else {
      return {
        headers: {
          ...headers
        }
      }
    }
  });

  const client = new ApolloClient({
    cache: cache,
    link: authLink.concat(httpLink)
  });
 
  return (
    <ApolloProvider client={client}>
        {children}
    </ApolloProvider>
  );
};
